import React from 'react';
import { TextWithLF } from '@doda/common/src/components/TextWithLF';
import { SectionItem } from '../../SectionItem';

/**
 * ReasonOfLimitAgeのProps
 */
interface ReasonOfLimitAgeProps {
  /** 年齢制限理由 */
  ageLimitDisplay: string;
}

/**
 * 年齢制限理由を表示するコンポーネント
 *
 * @param {string} props.ageLimitDisplay - 年齢制限理由
 */
export const ReasonOfLimitAge: React.FC<ReasonOfLimitAgeProps> = ({
  ageLimitDisplay,
}) => {
  return (
    <SectionItem label="年齢制限理由">
      <TextWithLF text={ageLimitDisplay} />
    </SectionItem>
  );
};
